module.exports = __webpack_public_path__ + "static/media/tunnel.adad15d0.svg";